import React from 'react';
import {
	Message,
	useConversationMessageQuery,
} from '../../../../graphql/graphql';
// @ts-ignore
import styles from './NotificationDetail.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import Loading from '../../../../Components/Loading';
import { useAppContext } from '../../../../Services/AppContext';
import moment from 'moment-timezone';
import useNotificationTemplate from '../../Hooks/useNotificationTemplate';

interface Props {
	notificationId: string;
}

const NotificationDetail: React.FC<Props> = ({ notificationId }) => {
	const { dateFormatMoment } = useAppContext();
	const { data, isLoading } = useConversationMessageQuery({
		id: notificationId,
	});

	const { formattedMessage } = useNotificationTemplate(
		data?.message as Message,
	);

	if (isLoading) {
		return <Loading />;
	}
	const date = moment(data?.message?.createdAt).format(
		dateFormatMoment + ' HH:mm',
	);

	return (
		<div className={styles.wrapper}>
			<Text
				className={styles.title}
				tx='component.workplaceAndWorkers.notification2'
				firstUpper
			/>
			<div className={styles.date}>{date}</div>
			<div className={styles.label}>{data?.message?.content?.title}</div>
			<div>{formattedMessage()}</div>
		</div>
	);
};

export default NotificationDetail;
